export default "__VITE_ASSET__Clb3TmpU__"